import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class StudentAllHistoryService {
  readonly baseURL = sessionStorage.getItem('NbaseURLs');
  constructor(private http: HttpClient) { }

  //ViewStudLedgerDet(Admno: string, YearCode: Number): Observable<any> {
  ViewStudAllHistDuesOpening(ShiftId: number, YearCode: number,AdmNo: string): Observable<any> {
    debugger;
    //ViewStudentPrevDuesDet
    return this.http.get<any>(this.baseURL + '/ViewStudAllHistDuesOpening?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&AdmNo=' + AdmNo)
    .pipe(retry(1), catchError(this.handleError));
  }
  ViewStudAllHistDuesCreated(ShiftId: number, YearCode: number, AdmNo: string): Observable<any> {
    debugger;
    //ViewStudentPrevDuesDet
    return this.http.get<any>(this.baseURL + '/ViewStudAllHistDuesCreated?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&AdmNo=' + AdmNo)
      .pipe(retry(1), catchError(this.handleError));
  }


  ViewStudFeesDet(ShiftId: number, YearCode: number, AdmNo: string): Observable<any> {
    debugger;
    //ViewStudentPrevDuesDet
    return this.http.get<any>(this.baseURL + '/ViewStudAllHistFeesDet?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&AdmNo=' + AdmNo)
      .pipe(retry(1), catchError(this.handleError));
  }

  GetAnyChanges(ShiftId: number, YearCode: number, AdmNo: string): Observable<any> {
    debugger;
    //ViewStudentPrevDuesDet
    return this.http.get<any>(this.baseURL + '/GetAnyChanges?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&AdmNo=' + AdmNo)
      .pipe(retry(1), catchError(this.handleError));
  }

  ViewSumofStudentAmtSum(ShiftId: number, YearCode: number, AdmNo: string): Observable<any> {
    debugger;
    //ViewStudentPrevDuesDet
    return this.http.get<any>(this.baseURL + '/ViewSumofStudentAmtSum?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&AdmNo=' + AdmNo)
      .pipe(retry(1), catchError(this.handleError));
  }

  ViewStudLedgerDetSum(ShiftId: number, YearCode: number, CSCode: string): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDetAllSum?ShiftId=' + ShiftId + '&&YearCode=' + YearCode + '&&CSCode=' + CSCode)
      .pipe(retry(1), catchError(this.handleError));
  }

  GetCourses(): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/GetCourses?YearCode=' + parseInt(sessionStorage.getItem('YearCode')))
      .pipe(retry(1), catchError(this.handleError));
  }

  ViewStudFeeDetailsDet(Admno: string,YearCode: Number): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDet?Admno=' + Admno + '&&YearCode=' + YearCode);
  }
  ViewStudFeeDetailsDetAll(): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDetAll')
    .pipe(retry(1), catchError(this.handleError));
  }
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
